import { getCustomerToken } from "../../api/network";
import { getDWSUrl, getEmblemWizardUrl } from "../../config";

const ASSETS_ROOT = 'https://assets.stahls.com/stahls/content/images/';
const DWS_WIZARD_URL = "https://" + getDWSUrl();

export interface ServiceType {
  id: string;
  name: string;
  description: string;
  image: string;
  targetSite: string;
  isBaseOption?: boolean;
}

export const BASE_OPTIONS: ServiceType[] = [
  {
    id: 'DWS_BASE',
    name: 'DWS - Upload Your Artwork',
    description: '',
    image: '',
    targetSite: 'DWS',
    isBaseOption: true
  },
  {
    id: 'EMBLEM_WIZARD_BASE',
    name: 'Emblem Wizard',
    description: '',
    image: '',
    targetSite: 'EMBLEM_WIZARD',
    isBaseOption: true
  }
];

export const SERVICE_TYPES: ServiceType[] = [
  {
    id: 'CadPrintz',
    name: 'CAD-PRINTZ® Digital Transfers',
    description: 'Are full-color designs digitally printed. Available in transfers for heat application or non-apparel items such as decals and stickers. There is a $25 minimum.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-CadPrintz.jpg`,
    targetSite: 'DWS'
  },
  {
    id: 'UltraColorDTFTransfers',
    name: 'UltraColor® MAX DTF Transfers',
    description: 'Are finely detailed, full color designs printed with direct to film technology. Artwork is printed exactly as uploaded. Available in transfers for heat application.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-UltraColorDTFTransfers.jpg`,
    targetSite: 'DWS'
  },
  {
    id: 'CustomCut',
    name: 'Custom Cut Designs',
    description: 'Are 1,2 or 3-color designs cut from the most popular CAD-CUT® and Twill materials. Sew and no-sew options are available. Minimum order is 5 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-CustomCut.jpg`,
    targetSite: 'DWS'
  },
  {
    id: 'CustomCutLetters',
    name: 'Custom Cut Letters',
    description: 'Are your font and size cut from the most popular Stahls\' materials. Letters arrive loose and require hand placement. Minimum order is 5 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-CustomCutLetters.jpg`,
    targetSite: 'DWS'
  },
  {
    id: 'CustomCutNumbers',
    name: 'Custom Cut Numbers',
    description: 'Are your font and size cut from the most popular Stahls\' materials. Numbers arrive loose and require hand placement. Minimum order is 5 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-CustomCutNumbers.jpg`,
    targetSite: 'DWS'
  },
  {
    id: '3DEmbrPatches',
    name: '3D Embroidered Patches',
    description: 'Gives logos a 3-dimensional look on hats, bags and jackets. Available in heat applied or pressure sensitive. Minimum order is 25 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-3DEmbrPatches.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'EmbrPatches',
    name: 'Embroidered & Print Stitch Patches',
    description: 'Provide the classic look of embroidery without threading a needle. Available in heat applied or pressure sensitive. Minimum order is 25 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-EmbrPatches.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'Flexbroidery',
    name: 'Flexbroidery',
    description: 'Flexible embroidery solution that combines the look of embroidery with the flexibility of heat transfer vinyl. Perfect for stretchy fabrics.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-Flexbroidery.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'FlexStyle',
    name: 'FlexStyle® Emblems',
    description: 'Are full color, textured emblems. Available in heat applied or pressure sensitive to decorate apparel and non-apparel items. Minimum order is 25 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-FlexStyle.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'ChenillePatches',
    name: 'Chenille Patches',
    description: 'Premium chenille material patches that provide a classic, vintage look. Perfect for letterman jackets, hats, and bags. Available in various colors.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-ChenillePatches.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'LeatherPatches',
    name: 'Leather & Suede Patches (Genuine & Faux)',
    description: 'Are available in genuine and faux leather material. Logos are etched onto the surface. Available in heat applied or pressure sensitive. Minimum order is 25 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-LeatherPatches.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'FlexStyleHolographic',
    name: 'FlexStyle® Holographic Emblems',
    description: 'Are textured, lenticular emblems that flip between 2 images. Available in heat applied or pressure sensitive to decorate apparel and non-apparel items. Minimum order is 25 pieces.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-FlexStyleHolographic.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'PVCEmblems',
    name: 'PVC Patch',
    description: 'Durable, weather-resistant patches made from flexible PVC material. Perfect for outdoor gear, uniforms, and promotional items. Available in full color.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-PVCEmblems.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'WovenPatches',
    name: 'Woven Patches',
    description: 'Traditional woven patches with fine detail and professional finish. Perfect for uniforms, corporate apparel, and promotional items.',
    image: `${ASSETS_ROOT}wizards/dynamic/artworkUpload/serviceType-WovenPatches.jpg`,
    targetSite: 'EMBLEM_WIZARD'
  },
  {
    id: 'CustomPatches',
    name: 'Custom Patches',
    description: 'Fully customizable patches available in various materials and finishes. Perfect for any application with endless design possibilities.',
    image: `${DWS_WIZARD_URL}/images/custom-patches.webp`,
    targetSite: 'DWS'
  }
];

export const generateServiceUrl = (serviceType: ServiceType): string => {
  let baseUrl = '';
  const params = new URLSearchParams();

  const currentUrlParams = new URLSearchParams(window.location.search);
  const customerId = currentUrlParams.get('customerId');
  const customerToken = getCustomerToken ? getCustomerToken() : currentUrlParams.get('customerToken');

  if (customerId) {
    params.append('customerId', customerId);
  }
  if (customerToken) {
    params.append('customerToken', customerToken);
  }

  params.append('source', 'dashboard');

  //asierad: include language feature in launcher while preventing merge conflicts
  const lang = currentUrlParams.get('lang');
  if (lang) {
    params.append('lang', lang);
  }
  //asierad: end merge conflict

  if (serviceType.targetSite === 'DWS') {
    baseUrl = DWS_WIZARD_URL;

    const cookieValues: string[] = [];
    const allParams = new URLSearchParams(window.location.search);
    allParams.append('source', 'dashboard');

    if (customerId) {
      allParams.set('customerId', customerId);
    }

    if (customerToken) {
      allParams.set('customerToken', customerToken);
      params.set('customerToken', customerToken);
    }

    if (!serviceType.isBaseOption) {
      params.append('serviceType', serviceType.id);
      allParams.append('serviceType', serviceType.id);
    }

    allParams.forEach((value, key) => {
      cookieValues.push(`__dws_${encodeURIComponent(key)}=${encodeURIComponent(value)}`);
    });

    localStorage.setItem('dws-cookie', cookieValues.join('; '));

  } else if (serviceType.targetSite === 'EMBLEM_WIZARD') {
    baseUrl = getEmblemWizardUrl() ?? '';

    if (!serviceType.isBaseOption) {
      params.append('productType', serviceType.id);
    }
  }

  return `${baseUrl}?${params.toString()}`;
};